/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum FragmentNames {
  APPLICATION = 'application',
  APPROVAL_FORWARD_MODAL = 'approval-forward-modal',
  APPROVAL_ITEM = 'approval-item',
  APPROVALS = 'approvals',
  APPROVALS_ATTACHMENTS_LIST = 'approvals-attachments-list',
  APPROVALS_LIST = 'approvals-list',
  ASSIGN_TERMS = 'assign-terms',
  CUSTOM_ROUTE = 'custom-route',
  DISAPPROVE_CONFIRM_MODAL = 'disapprove-confirm-modal',
  INACTIVITY = 'inactivity',
  INFORM_OPINION_MODAL = 'inform-opinion-modal',
  LOGIN = 'login',
  MODAL_NOTE = 'modal-note',
  OPINION_REQUEST = 'opinion-request',
  PROFILE = 'profile',
  PURCHASE_APPROVAL = 'purchase-approval',
  ROOT = 'root',
  SETTINGS = 'settings',
  SPOTLIGHT = 'spotlight',
  TERMS_AND_COOKIES_LIST = 'terms-and-cookies-list',
  TERMS_OF_PRIVACY_DETAIL = 'terms-of-privacy-detail',
  TERMS_OF_USE = 'terms-of-use',
  TERMS_OF_USE_DETAIL = 'terms-of-use-detail',
}
export { FragmentNames };
